import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'for_how_many_months_are_recs_of_disciplinary_actions_maintained'

export const dataPointDefinition = {
  retracedId: 'for_how_many_months_are_recs_of_disciplinary_actions_maintained',
  name: 'For how many months are records of disciplinary actions maintained in worker personnel files?',
  description:
    'The intent of this question is to understand how long records of disciplinary actions are maintained. \r\r\n\r\r\nIn other words, for what amount of time are they maintained within a worker personnel file. As measured in number of months. Please select the most appropriate option.',
  meta: {},
  fieldTypeId: 'NUMBER',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'number',
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'discp-6--1',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 11610,
  sectionId: '2.2.4.4',
  impactArea: 'Discipline',
  impactAreaId: 'DISCIPLINE',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
